export class tuttiNodiIponimiaService {

  tuttiNodiIponimia(event) {
    console.log("funzione tutti nodi iponimia");

    let nodoDBClick = event.target;
    let nodoDBincomers = event.target.incomers();
    let nodoDBoutgoers = event.target.outgoers();

    var nodoDBincomersPredecessors = nodoDBincomers.sources().predecessors().sources();
    var nodoDBincomersSuccessors = nodoDBincomers.sources().successors().targets();
    var edgenodoDBincomersPredecessors = nodoDBincomers.predecessors();
    var edgenodoDBincomersSuccessors = nodoDBincomers.successors();

    var nodoDBOutgoersSuccessors = nodoDBoutgoers.targets().successors().targets();
    var nodoDBOutgoersPredecessors = nodoDBoutgoers.targets().predecessors().sources();
    var edgenodoDBOutgoersPredecessors = nodoDBoutgoers.predecessors();
    var edgenodoDBOutgoersSuccessors = nodoDBoutgoers.successors();

    nodoDBincomers.style("display", "element");
    nodoDBoutgoers.style("display", "element");

    // istruzioni per colorare nodi e archi di secondo livello in grigio
    // incomers classe iponimia
    nodoDBincomersPredecessors.removeClass("iponimia");
    nodoDBincomersSuccessors.removeClass("iponimia");
    nodoDBincomersPredecessors.removeClass("iponimiaDBClick");
    nodoDBincomersSuccessors.removeClass("iponimiaDBClick");

    // incomers classe meronimia
    nodoDBincomersPredecessors.removeClass("meronimia");
    nodoDBincomersSuccessors.removeClass("meronimia");
    nodoDBincomersPredecessors.removeClass("meronimiaDBClick");
    nodoDBincomersSuccessors.removeClass("meronimiaDBClick");

    // incomers classe sinonimia
    nodoDBincomersPredecessors.removeClass("sinonimia");
    nodoDBincomersSuccessors.removeClass("sinonimia");
    nodoDBincomersPredecessors.removeClass("sinonimiaDBClick");
    nodoDBincomersSuccessors.removeClass("sinonimiaDBClick");

    // edges
    edgenodoDBincomersPredecessors.removeClass("edges");
    edgenodoDBincomersSuccessors.removeClass("edges");

    // outgoers classe iponimia
    nodoDBOutgoersSuccessors.removeClass("iponimia");
    nodoDBOutgoersPredecessors.removeClass("iponimia");
    nodoDBOutgoersSuccessors.removeClass("iponimiaDBClick");
    nodoDBOutgoersPredecessors.removeClass("iponimiaDBClick");

    // outgoers classe meronimia
    nodoDBOutgoersSuccessors.removeClass("meronimia");
    nodoDBOutgoersPredecessors.removeClass("meronimia");
    nodoDBOutgoersSuccessors.removeClass("meronimiaDBClick");
    nodoDBOutgoersPredecessors.removeClass("meronimiaDBClick");

    // outgoers classe sinonimia
    nodoDBOutgoersSuccessors.removeClass("sinonimia");
    nodoDBOutgoersPredecessors.removeClass("sinonimia");
    nodoDBOutgoersSuccessors.removeClass("sinonimiaDBClick");
    nodoDBOutgoersPredecessors.removeClass("sinonimiaDBClick");

    // edges
    edgenodoDBOutgoersSuccessors.removeClass("edges");
    edgenodoDBOutgoersPredecessors.removeClass("edges");


    // se nodi sono tra 20 e 200
    if (nodoDBincomers.sources().toArray().length > 20 && nodoDBincomers.sources().toArray().length < 200
      || nodoDBoutgoers.targets().toArray().length > 20 && nodoDBoutgoers.targets().toArray().length < 200) {
      // layout iponimi
      var iponimiIncomers = event.target.incomers('edge[relationType = "hyponym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var iponimiOutgoers = event.target.outgoers('edge[relationType = "hyponym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      iponimiIncomers.run();
      iponimiOutgoers.run();

      if (nodoDBincomersPredecessors.toArray().length > 20 || nodoDBincomersSuccessors.toArray().length > 20
        && nodoDBOutgoersSuccessors.toArray().length > 20 || nodoDBOutgoersPredecessors.toArray().length > 20) {
        
          // nodes
        nodoDBincomersPredecessors.addClass("2livello");
        nodoDBincomersSuccessors.addClass("2livello");
        nodoDBOutgoersSuccessors.addClass("2livello");
        nodoDBOutgoersPredecessors.addClass("2livello");

        // edges
        edgenodoDBincomersPredecessors.addClass("2livello");
        edgenodoDBincomersSuccessors.addClass("2livello");
        edgenodoDBOutgoersSuccessors.addClass("2livello");
        edgenodoDBOutgoersPredecessors.addClass("2livello");

        nodoDBClick.removeClass("2livello");
        nodoDBincomers.sources().removeClass("2livello");
        nodoDBincomers.removeClass("2livello");
        nodoDBoutgoers.targets().removeClass("2livello");
        nodoDBoutgoers.removeClass("2livello");
      }

    } else if (nodoDBincomers.sources().toArray().length > 200 || nodoDBoutgoers.targets().toArray().length > 200) {
      // layout iponimi
      var iponimiIncomers = event.target.incomers('edge[relationType = "hyponym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var iponimiOutgoers = event.target.outgoers('edge[relationType = "hyponym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      iponimiIncomers.run();
      iponimiOutgoers.run();

      if (nodoDBincomers.sources().incomers().sources().toArray().length > 20 || nodoDBincomers.sources().outgoers().targets().toArray().length > 20
        && nodoDBoutgoers.targets().outgoers().targets().toArray().length > 20 || nodoDBoutgoers.targets().incomers().sources().toArray().length > 20) {

        // nodes
        nodoDBincomersPredecessors.addClass("2livello");
        nodoDBincomersSuccessors.addClass("2livello");
        nodoDBOutgoersSuccessors.addClass("2livello");
        nodoDBOutgoersPredecessors.addClass("2livello");
        // edges
        edgenodoDBincomersPredecessors.addClass("2livello");
        edgenodoDBincomersSuccessors.addClass("2livello");
        edgenodoDBOutgoersSuccessors.addClass("2livello");
        edgenodoDBOutgoersPredecessors.addClass("2livello");

        nodoDBClick.removeClass("2livello");
        nodoDBincomers.sources().removeClass("2livello");
        nodoDBincomers.removeClass("2livello");
        nodoDBoutgoers.targets().removeClass("2livello");
        nodoDBoutgoers.removeClass("2livello");
      }
      // posizionamento nodi nel caso di quantità inferiore a 20
    } else {

      nodoDBClick.removeClass("2livello");
      nodoDBincomers.sources().removeClass("2livello");
      nodoDBincomers.removeClass("2livello");
      nodoDBoutgoers.targets().removeClass("2livello");
      nodoDBoutgoers.removeClass("2livello");

      // posizioni nodo cliccato, nodi entranti, nodi uscenti DA RIVEDERE
      nodoDBincomers.positions(function (nodi, i) {
        var xc = nodoDBClick.position('x');
        var yc = nodoDBClick.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc + 75;
        return {
          x: xRet,
          y: yRet
        };

      });

      nodoDBoutgoers.positions(function (nodi, i) {
        var xc = nodoDBClick.position('x');
        var yc = nodoDBClick.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc - 75;
        return {
          x: xRet,
          y: yRet
        };
      });
    }

    return true
  }
}